/**
 * reasonTypeApi.js
 * ----------------
 * API client for Inquiry Reason Master (ReasonType) using createMasterApiClient.
 * Connects directly to FastAPI backend /reason-type/ endpoints.
 * 100% conforming to module_implementation_standards.md.
 */
import { createMasterApiClient } from '../../common/masterApiFactory';

export const reasonTypeClient = createMasterApiClient('reason-type');

export const listReasonTypes = (params) => reasonTypeClient.list(params);
export const getReasonTypeDetail = (id) => reasonTypeClient.getById(id);
export const createReasonType = (data) => reasonTypeClient.create(data);
export const updateReasonType = (id, data) => reasonTypeClient.update(id, data);
export const archiveReasonType = (id) => reasonTypeClient.archive(id);
export const deleteReasonType = (id) => reasonTypeClient.remove(id);
export const getReasonTypeOptions = () => reasonTypeClient.getDropdownOptions();
